// action enums
export enum ActionsEnum {
  RESEND_VERIFICATION_EMAIL = 'RESEND_VERIFICATION_EMAIL',
  RESEND_VERIFICATION_EMAIL_SUCCESS = 'RESEND_VERIFICATION_EMAIL_SUCCESS',
  RESEND_VERIFICATION_EMAIL_ERROR = 'RESEND_VERIFICATION_EMAIL_ERROR',
}

export interface IShouldOpenDialogPayload {
  shouldOpenDialog: boolean;
}

// action definitions
export interface IResendVerificationEmail {
  type: ActionsEnum.RESEND_VERIFICATION_EMAIL;
  payload: IShouldOpenDialogPayload;
}

export interface IResendVerificationEmailSuccess {
  type: ActionsEnum.RESEND_VERIFICATION_EMAIL_SUCCESS;
  payload: IShouldOpenDialogPayload;
}

export interface IResendVerificationEmailError {
  type: ActionsEnum.RESEND_VERIFICATION_EMAIL_ERROR;
  payload: IShouldOpenDialogPayload;
}

// action creators
export const resendVerificationEmail = (
  shouldOpenDialog
): IResendVerificationEmail => ({
  type: ActionsEnum.RESEND_VERIFICATION_EMAIL,
  payload: { shouldOpenDialog },
});

export const resendVerificationEmailSuccess = (
  shouldOpenDialog: boolean
): IResendVerificationEmailSuccess => ({
  type: ActionsEnum.RESEND_VERIFICATION_EMAIL_SUCCESS,
  payload: { shouldOpenDialog },
});

export const resendVerificationEmailError = (
  shouldOpenDialog: boolean
): IResendVerificationEmailError => ({
  type: ActionsEnum.RESEND_VERIFICATION_EMAIL_ERROR,
  payload: { shouldOpenDialog },
});
